const storeToken = $infosBase.data('store-token');
const cartToken = $infosBase.data('cart-token');
const cartId = $infosBase.data('cart-id');
const landingPage = $infosBase.data('lp');
const productUrl = $infosBase.data('product-url');
const hasKit = $infosBase.data('has-kit');
const hasVariant = $infosBase.data('has-variant');
const storeModel = $infosBase.data('store-model');
const coreAssetsPath = $infosBase.data('core-assets');
const checkoutStepsEnable = $('body').hasClass('steps-layout');
const checkoutStepsColsEnable = $('body').hasClass('steps-cols-layout');
const gatewayRetry = $infosBase.data('gateway-retry');
const checkoutDigitalActive = $('body').hasClass('checkout-digital-active');
const checkoutNoAddress = $('body').hasClass('checkout-no-address');
const recaptchaEnabled = $infosBase.data('recaptcha-enabled');
const recaptchaSitekey = $infosBase.data('recaptcha-sitekey');

// Ajusta a altura do conteúdo no MOBILE
function updateMainHeight() {
  const $elsOut = $('#header, #countdown, #footer');
  let heightOut = 0;
  $elsOut.each(function () {
    const $el = $(this);
    if ($el.length > 0 && $el.is(':visible')) {
      heightOut += $el.outerHeight();
    }
  });
  let contentHeight = $(window).height() - heightOut;
  $('.main').css('min-height', contentHeight);
}
updateMainHeight();

// ------------------------------------
// Tooltips
// ------------------------------------

// Instância
var coTooltip;

function disablePrevTooltips() {
  tippyInstance.forEach((instance) => {
    instance.destroy();
  });
}

if (typeof tippy === 'function') {
  disablePrevTooltips();
  initCoTooltip();
}

// Inicializa a instância do Tippy.js
function initCoTooltip() {
  coTooltip = tippy('[data-tippy-content]', {
    theme: 'co-tooltip',
    maxWidth: 200,
  });
}

// Horizontal and vertical window resize events.
(function () {
  var win = jQuery(window),
    prev_width = win.width(),
    prev_height = win.height();
  win.on('resize', function () {
    var width = win.width(),
      height = win.height();

    if (width !== prev_width) {
      win.trigger('hresize');
    }
    if (height !== prev_height) {
      win.trigger('vresize');
    }
    prev_width = width;
    prev_height = height;
  });
})();

// Retorna o valor de uma variável CSS
function getCSSVar(nomeDaVariavel, elemento = document.documentElement) {
  const styles = getComputedStyle(elemento);
  return styles.getPropertyValue(nomeDaVariavel).trim();
}
